export default function QueueDraftCard({ draft, draftSelected }) {
  const getDate = (date) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const newDate = new Date(date).toLocaleDateString(undefined, options);
    return newDate;
  };

  return (
    <button
      onClick={() => draftSelected(draft.id)}
      className="group flex w-full cursor-pointer flex-col items-start justify-between space-y-2 rounded-lg border border-gray-200 bg-white text-left duration-150 hover:border-blue-500 hover:ring-1 hover:ring-blue-500"
    >
      <div className="flex w-full flex-col">
        <div className="flex w-full flex-row items-center justify-between space-x-1 rounded-md px-4 pt-4">
          {draft.type === 'essay' ? (
            <div className="flex flex-row items-center justify-start space-x-1">
              {/*                         <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                        </svg>
 */}

              <p
                className={`flex-1 text-left text-base font-semibold leading-tight tracking-tightish line-clamp-2 ${
                  draft.title ? 'text-gray-900' : 'text-gray-500'
                }`}
              >
                {draft.title ? draft.title : 'Untitled'}
              </p>
            </div>
          ) : null}
        </div>

        <div className="mt-1 w-full px-4">
          <p className="overflow-hidden whitespace-pre-wrap text-sm text-gray-900 line-clamp-3">
            {draft.text}
          </p>
        </div>
      </div>

      <div className="flex w-full flex-row items-center justify-between space-x-1 border-t border-gray-100 p-2 group-hover:border-gray-200">
        <div className="flex flex-row items-center justify-start space-x-2">
          {draft.type === 'essay' ? (
            <div className="max-w-min rounded-[4px] bg-orange-100 px-1.5 py-0.5 text-xs font-medium text-orange-600">
              Essay
            </div>
          ) : (
            <div className="max-w-min rounded-[4px] bg-blue-100 px-1.5 py-0.5 text-xs font-medium text-blue-600">
              Thread
            </div>
          )}

          <div className="text-xs font-medium text-gray-500">
            {getDate(draft?.timestamp)}
          </div>
        </div>

        {/* <div className='flex flex-row space-x-1 items-center justify-end text-gray-600'>

                    <button className='p-1 rounded-md hover:bg-gray-200 text-gray-500 hover:text-gray-700'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                            <path fillRule="evenodd" d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" clipRule="evenodd" />
                        </svg>




                    </button>





                </div> */}
      </div>
    </button>
  );
}
